<template>
  <div id="app">
    <div id="Head" style="">
      <div id="bottons" style="">
        <div id="bottons-img" style="">
          <img src="./assets/logo.png" style="vertical-align: middle" />
        </div>
      </div>
      <div class="divleft1">
        <p class="divleftp1"><strong>清伴APP</strong></p>
        <p class="divleftp2">随时有个人，陪你聊聊天</p>
      </div>
      <div class="loadtop">
        <div class="loaddiv1">
          <div class="loaddiv2" id="clickDownBtn" @click="clickDownBtn">
            立即下载
          </div>
        </div>
      </div>
    </div>
    <div style="float: left">
      <img src="./assets/bg.png" alt="" class="bg" />
    </div>

    <template v-if="isShowIosTip">
      <div class="shade" @click="shadeClick">
        <img src="./assets/ios_tip.png" alt="" class="bg" />
      </div>
    </template>

    <template v-if="isShowAndroidTip">
      <div class="shade">
        <img src="./assets/weixin_tip.png" alt="" class="bg" />
      </div>
    </template>
  </div>
</template>

<script>
import { getUserEnv } from "@/api/common";
import config from "@/api/config";
import axios from "axios";
import { copy } from "iclipboard";

export default {
  name: "App",
  data() {
    return {
      userEnv: {},
      // 是否点击第一个下载按钮（默认的下载按钮）
      userClickDownBtn: false,
      iv: "",
      // 是否隐藏首页默认的div容器
      hideDefaultDiv: false,
      expire: true,
      config: {},
      user: {},
      user_code: "",
      user_code1: "",
      user_code2: "",
    };
  },

  created: function () {
    // 获取环境数据
    this.userEnv = getUserEnv();
    this.config = config;
    // 设置邀请码
    this.user_code1 = this.getUrlKey("invite_code");
    this.user_code2 = this.getUrlKey("shareCode");
    if (this.user_code1 && this.user_code2 && this.user_code1 === this.user_code2) {
      this.user_code = this.user_code2
    }
  },
  methods: {
    getUrlKey(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },
    clickDownBtn() {
      // 复制url中的分享邀请码到剪贴板
      if (this.user_code) {
        copy(this.config.sharePrefix + this.user_code);
        axios.post(
            this.config.apiDomain +
            "/api/invite/browse?invite_code=" +
            this.user_code
        );
      }
      this.userClickDownBtn = true;

      if (this.userEnv.isiOS) {
        if (!this.userEnv.isWeiXin && !this.userEnv.isQQ) {
          this.hideDefaultDiv = true;
          location.href = this.config.iosUrl;
        }
      }
      if (this.userEnv.isAndroid) {
        if (!this.userEnv.isWeiXin && !this.userEnv.isQQ) {
          location.href = this.config.androidUrl;
        }
      }
    },
  },
  computed: {

    //是否显示ios引导页
    isShowIosTip() {
      //点击 && 是微信
      return (
          this.userClickDownBtn &&
          (this.userEnv.isWeiXin || this.userEnv.isQQ) &&
          this.userEnv.isiOS
      );
    },

    //是否显示安卓引导页
    isShowAndroidTip() {
      //点击 && 是微信 或者 qq && 安卓
      return (
          this.userClickDownBtn &&
          (this.userEnv.isWeiXin || this.userEnv.isQQ) &&
          this.userEnv.isAndroid
      );
    },
  },
};
</script>

<style lang="scss">
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
font,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
center,
dl,
dt,
dd,
ol,
ul,
li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
textarea,
input {
  margin: 0;
  padding: 0;
}

address,
cite,
dfn,
em,
var,
i {
  font-style: normal;
}

body {
  font-size: 16px;
  line-height: 1.5;
  font-family: "Microsoft Yahei", "simsun", "arial", "tahoma";
  color: #222;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

h1,
h2,
h3,
h4,
h5,
h6,
th {
  font-size: 100%;
  font-weight: normal;
}

button,
input,
select,
textarea {
  font-size: 100%;
}

fieldset,
img {
  border: 0;
}

a {
  text-decoration: none;
  color: #666;
  background: none;
}

ul,
ol {
  list-style: none;
}

:focus {
  outline: none;
}

.clearfix {
  clear: both;
  content: "";
  display: block;
  overflow: hidden;
}

.clear {
  clear: both;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

  .bg {
    width: 100%;
    height: 100%;
    background-color: #15172c;
  }

  .shade {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    img {
    }
  }

  .ios-guide {
    .ios-down-div {
      position: fixed;
      bottom: 120px;
      width: 100%;
    }

    .ios-down-div2 {
      position: fixed;
      bottom: 70px;
      width: 100%;
    }

    .ios-down-div3 {
      position: fixed;
      bottom: 20px;
      width: 100%;
    }
  }
  #Head {
    height: 70px;
    width: 100%;
    color: white;
    background-color: white;
    position: fixed;
    bottom: 0;
  }
  #bottons {
    width: 20%;
    height: 100%;
    float: left;
  }
  //#bottons-img {
  //  width: 80px;
  //  height: 70px;
  //  display: table-cell;
  //  vertical-align: middle;
  //  text-align: center;
  //}
  #bottons-img img {
    max-width: 60%;
    max-height: 100%;
    width: auto;
    height: auto;
    padding-top: 10px;
  }
  .divleft1 {
    width: 30%;
    height: 70px;
    float: left;
  }
  .divleftp1 {
    text-align: left;
    color: #222222;
    margin-top: 10px;
  }
  .divleftp2 {
    text-align: left;
    color: #666666;
    font-size: 10px;
    margin-top: 5px;
  }
  .loadtop {
    float: right;
    margin-right: 1rem;
  }
  .loaddiv1 {
    width: 80px;
    height: 70px;
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }
  .loaddiv2 {
    //background-color: #930BF3;
    background: linear-gradient(to right, #930BF3, #E61EFA, #FDB287); /* 渐变从紫到粉紫 */
    color: white;
    border-radius: 10%;
    width: 100px;
    height: 40px;
    line-height: 40px;
  }
}
</style>
